


















































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import moment from 'moment';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import { delay, difference, uniq, without } from "lodash";
import Snackbar from '@/components/shared/Snackbar.vue';

@Component({
    components: {
        FilterMenu,
        Snackbar
    }
})
export default class SellsDetailStockSelector extends Vue {
    menu2: boolean = false;
    searchSellCustomerStock: string = "";
    dialog: boolean = false;
    dialogPallets: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Inbound', value: 'codeInbounds' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Location', value: 'location', sortable: false },
        { text: 'Total cases', value: 'availableCasesFinal' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'availableGoodsFinal' },
        { text: 'Weight', value: 'weight' },
        { text: 'Reference dossier number', value: 'referenceInboundCode' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Language', value: 'language' },
        { text: 'Douana document', value: 'documentation' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    headersPallets: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet Id', value: 'idPallet' },
        { text: 'Total cases', value: 'availableCasesFinal' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Location', value: 'location', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IStock = {
        id: "",
        idInbound: "",
        idGood: "",
        goodName: "",
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        idInboundDeliveryNoteDetail: "",
        warehouseName: "",
        language: "",
        documentation: false,
        idWarehouse: "",
        availableCasesFinal: 0,
        allocatedCases: 0,
        allocatedGoods: 0,
        availableGoodsFinal: 0,
        availablePalletsAmountFinal: 0,
        casesPerPallet: 0,
        codeInbounds: "",
        codeOutbound: "",
        companyDestination: "",
        companySourceName: "",
        customerName: "",
        dateIn: new Date(),
        dateOut: new Date(),
        idCompanyDestination: "",
        idCompanySource: "",
        idCustomer: "",
        idListPallet: "",
        idMovementDetail: "",
        idNoticeOfLossDetail: "",
        idOutboundDeliveryNoteDetail: "",
        idOutboundDetail: "",
        idPallet: "",
        isSelected: false,
        isTransformed: "",
        listPalletName: "",
        location: "",
        palletsAmount: 0,
        palletsAmountSell: 0,
        referenceInboundCode: "",
        sellCases: 0,
        sellGoods: 0,
        totalGoodsSell: 0,
        codeDestination: "",
        weight: 0,
        idPalletCustomer: "",
        goodCode: "",
        sku: ""
    }
    defaultItem : IStock = {
        id: "",
        idInbound: "",
        idGood: "",
        goodName: "",
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        idInboundDeliveryNoteDetail: "",
        warehouseName: "",
        language: "",
        documentation: false,
        idWarehouse: "",
        availableCasesFinal: 0,
        allocatedCases: 0,
        allocatedGoods: 0,
        availableGoodsFinal: 0,
        availablePalletsAmountFinal: 0,
        casesPerPallet: 0,
        codeInbounds: "",
        codeOutbound: "",
        companyDestination: "",
        companySourceName: "",
        customerName: "",
        dateIn: new Date(),
        dateOut: new Date(),
        idCompanyDestination: "",
        idCompanySource: "",
        idCustomer: "",
        idListPallet: "",
        idMovementDetail: "",
        idNoticeOfLossDetail: "",
        idOutboundDeliveryNoteDetail: "",
        idOutboundDetail: "",
        idPallet: "",
        isSelected: false,
        isTransformed: "",
        listPalletName: "",
        location: "",
        palletsAmount: 0,
        palletsAmountSell: 0,
        referenceInboundCode: "",
        sellCases: 0,
        sellGoods: 0,
        totalGoodsSell: 0,
        codeDestination: "",
        weight: 0,
        idPalletCustomer: "",
        goodCode: "",
        sku: ""
    }

    goodNamesFilter : string[] = [];
    inboundCodeFilter : string[] = [];
    maxTotalCases : number = 0;
    loadingVariable : boolean = false;

    @Prop({ type: Array, required: true })
    StockList !: IStock[];
    @Prop({ type: Array, required: true })
    StockListCustomerPalletsAmount !: IStock[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop()
    value !: IStock[];

    selectedStockCustomerToSell : IStock[] = [];
    selectedSellDetail : IStock = {} as IStock;
    bestBeforeDate: string = new Date().toISOString().substr(0, 10);
    dataReady: boolean = false;

    get formTitle() { return this.editedIndex === -1 ? 'Add customer stock' : 'Edit customer stock'; }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    editSellCustomerStock (item: any, dbox = true) {
        this.maxTotalCases = item.availableCasesFinal;
        this.editedIndex = this.StockList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    @Watch('StockList', { immediate: true })
    onStockListChanged() {
        if (this.StockList && this.StockList.length > 0) {
            this.dataReady = true;
        }
    }

    @Watch('value')
    updateSelection(newValue : IOutboundDetail[] | null) {
        if (newValue !== null) {
            if (newValue!.length === 0) {
                this.selectedStockCustomerToSell = [];
            }
        }
    }

    @Watch('selectedStockCustomerToSell')
    onChangeSelectedCustomerStockDetail() {
        if (this.selectedStockCustomerToSell.length > 0) {
            this.$emit('input', this.selectedStockCustomerToSell);
        } else {
            this.$emit('input', null);
        }
    }

    get goodNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.goodName !== null)
            .map(b => b.goodName)
        );
    }

    get inboundCodes() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.codeInbounds !== null)
            .map(b => b.codeInbounds)
        );
    }

    CalculateGoods() {
        if (this.editedItem.availableCasesFinal > 0 && this.editedItem.goodsPerCase > 0) {
            this.editedItem.totalGoods = this.editedItem.availableCasesFinal * this.editedItem.goodsPerCase;
        }
    }

    async getPalletsCustomerStock(item: IStock) {
        await this.$emit('getStockPalletsAmount', item);
        this.selectedSellDetail = item;
        this.dialogPallets = true;
    }

    saveSellCustomerStock() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            // this.editedItem.bestBeforeDate = new Date(this.bestBeforeDate);
            let index = this.StockList.findIndex(i => i.id === this.editedItem.id);
            this.editedItem.totalCases = this.editedItem.availableCasesFinal;
            Object.assign(this.StockList[index], this.editedItem);
            this.selectedStockCustomerToSell = [];
            this.close();
        } else {
            this.showMessageWarning("Please, some fields have not passed the validation to be able to save.");
        }
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    get isLoading() {
        return !this.dataReady;
    }

    get stockItemsFiltered() : IStock[] {
        this.loadingVariable = true;
        let filteredList: IStock[] = this.StockList.filter(s => s.availableCasesFinal > 0);
        if (this.inboundCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeFilter.includes(b.codeInbounds));
        }
        if (this.goodNamesFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodNamesFilter.includes(b.goodName));
        }
        this.loadingVariable = false;
        return filteredList;
    }

    getLocations(location: string | null | undefined): string[] {
        if (!location) return [];

        return Array.from(
            new Set(
                location
                .split('|')
                .map(x => x.trim())
                .filter(x => x !== "")
            )
        );
    }

    getLocationPreview(location: string | null | undefined): string {
        const locations = this.getLocations(location);

        if (locations.length === 0) return "";
        if (locations.length === 1) return locations[0];
        if (locations.length === 2) return `${locations[0]}, ${locations[1]}`;

        return `${locations[0]}, ${locations[1]} +${locations.length - 2}`;
    }

    hasMultipleLocations(location: string | null | undefined): boolean {
        return this.getLocations(location).length > 1;
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
}
